enum EditingDocumentInputFieldType {
  CHECKBOX = 'checkbox',
  SIGNATURE = 'signature',
  TEXT = 'text',
}

export default EditingDocumentInputFieldType;
